import React, { Fragment } from 'react'
import { externalLaboratories } from '../../../constant';
import { Card, Col, Container, Row, Button, CardBody,Input} from 'reactstrap';
import { useLaboratories } from '../../../hooks/laboratoriesExternal/useLaboratories';
import { ModalLaboratories } from '../../../components/laboratories/ModalLaboratories';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';

export const IndexLaboratories = () => {


    const {
        modal, toggle, modalTitle, method, loading,
        handleInputChange, validaciones,
        states, municipalities, handleChangeState,
        id_external_laboratory, id_state, id_municipality, name_state, name_municipality, code,
        name, business_name, rfc, phone, address, colony, cp, email, web_site,
        saveCreate, saveUpdate, saveDelete,
        externalLaboratory, handleCreate, handleUpdate, handleDelete,
        navigateUpdate, handleSearchExternal,
        downloadExcel, 

        handleExportExcelLaboratory, loadingExport, closeModaLaboratories,
        handleClearExternal, searchExternal, loadingDownload, downloadReport

    } = useLaboratories();

        const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

        const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <button 
                    type="button"
                    onClick={() => navigateUpdate(rowData.id_external_laboratory)}
                    style={{
                    padding: "2px",
                    fontSize: "1rem",
                    height: "26px",
                    width: "26px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#6c6c6c",
                    border: "none",
                    color: "#fff"
                    }}
                    title="Exámenes"
                >
                    <i className="icofont icofont-laboratory" />
                </button>

                <button 
                    type="button"
                    onClick={() => downloadExcel(rowData.id_external_laboratory)}
                    style={{
                    padding: "2px",
                    fontSize: "1rem",
                    height: "26px",
                    width: "26px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#51bb25",
                    border: "none",
                    color: "#fff"
                    }}
                    title="Descargar"
                >
                    <i className="fa fa-file-excel-o" />
                </button>

                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_external_laboratory)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_external_laboratory)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };



    
    return (
        <Fragment>
            {/* <Breadcrumb parent="Catálogos" title="Listado de laboratorios externos" className="m-b-0" /> */}
            <div className='container-global-zoom'> 
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody className="p-1">
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                    <TitleDataTable
                                        titleTable={externalLaboratories}
                                        buttonActions={handleExportExcelLaboratory}
                                        titleButton="Laboratorios Externos"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear Laboratorio"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearchExternal}
                                        valueFilter={searchExternal}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearExternal}

                                        extraButton={true}
                                        extraButtonLabel="Reporte"
                                        titleReport="Reporte de laboratorio con precios"
                                        onExtraButtonClick={downloadReport}
                                        extraButtonDisabled={loadingDownload}

                                    />
                                </Col>

                                <div className="table-responsive">
                                    <DataTable
                                        value={externalLaboratory}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="code" header="Código" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name" header="Nombre del Laboratorio" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="business_name" header="Razón Social" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="rfc" header="RFC" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="email" header="Correo electrónico" headerStyle={headerStyle} style={cellStyle} />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                                    </DataTable>
                                </div>
                                <br />
                                <br />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <ModalLaboratories
                {
                ...{
                    modal, toggle, modalTitle, method, loading,
                    handleInputChange,
                    id_external_laboratory, id_state, id_municipality, name_state, name_municipality, code,
                    name, business_name, rfc, phone, address, colony, cp, email, web_site,
                    saveCreate, saveUpdate, saveDelete, validaciones,
                    states, municipalities, handleChangeState, handleUpdate, handleDelete, closeModaLaboratories
                }
                }
            />
        </Fragment>
    )
}
